import { render, staticRenderFns } from "./maintenance-bar.vue?vue&type=template&id=2012d50e&"
import script from "./maintenance-bar.vue?vue&type=script&lang=js&"
export * from "./maintenance-bar.vue?vue&type=script&lang=js&"
import style0 from "./maintenance-bar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports